



















import { Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { Action } from '@/api/model/action'
import { isAllowedUserForReferral } from '@/helpers/security'

@Component
export default class ColumnNextOrPreviousAction extends Vue {
    @Prop({ required: true }) referral!: Referral

    routeToDetail(referral: Referral) {
        if (!isAllowedUserForReferral(this.$currentUser, referral) && this.$currentUser.betaOptInEnabled) {
            return {
                name: 'one_contact_detail',
                params: {
                    contactId: referral.contact.id,
                    toOne: this.$currentUser.betaOptInEnabled,
                },
            }
        }

        return {
            name: 'tasks_detail',
            params: {
                referralId: referral.id,
                contactId: referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }

    colorForActionType(action: Action): string {
        switch (action.type) {
            case 'meeting': return 'kvUnitedBlue'
            case 'email': return 'vueOrange'
            case 'call': return 'vueViolet'
            case 'reminder': return 'pink'
            case 'letter': return 'indigo'
            case 'billing': return 'green'
            case 'update': return 'teal'
            default: return 'blue'
        }
    }

    get actionColor(): string|null {
        if (this.referral.nextOrPreviousAction === null) {
            return null
        }

        return `text-${this.colorForActionType(this.referral.nextOrPreviousAction)}-500`
    }
}
